(() => {
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const videos = document.querySelectorAll('video[data-ct-loop]:not([data-ct-ready])');

  const loadVideo = (video) => {
    if (video.dataset.ctReady) return;
    const source = document.createElement('source');
    source.src = video.dataset.src;
    source.type = 'video/mp4';
    video.appendChild(source);
    video.dataset.ctReady = 'true';
    video.load();
    if (!reduceMotion) video.play().catch(() => {});
  };

  videos.forEach((video) => {
    if (reduceMotion) {
      video.controls = true;
      video.removeAttribute('autoplay');
      return;
    }

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          loadVideo(video);
          video.play().catch(() => {});
        } else if (video.dataset.ctReady) {
          video.pause();
        }
      });
    }, { rootMargin: '80px 0px', threshold: 0.08 });
    observer.observe(video);
  });
})();
